import fetch from "auth/FetchInterceptor";

export const RoleService = {};

RoleService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  state = null,
}) => {
  let apiUrl = "/v1/role?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Did";
  else if (sort === "descend") apiUrl += "&order_by=%2Bid";
  if (searchText) apiUrl += "&name=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

RoleService.getDataSelect = async () => {
  let apiUrl = "/v1/role?order_by=%2Did";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

RoleService.getById = async (id) => {
  const apiUrl = `/v1/role/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

RoleService.createRole = async (data) => {
  const apiUrl = `/v1/role`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

RoleService.updateRole = async (data) => {
  const apiUrl = `/v1/role/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

RoleService.deleteRole = async (id, confirm = false) => {
  let apiUrl = `/v1/role/${id}`;
  if (confirm) apiUrl = `/v1/role/${id}?confirmed`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default RoleService;
